export default __webpack_public_path__ + "logo-01345852.png";